export class DoctorInfo {

  id: string;
  name: string;
  photoUrl: string;
  emailId: string;
  mobileNo: string;
  adminLicense: string;
  systemName: string;
  isLock: boolean;
  doctorId:string;
  address: string;
  backgroundColor: string = 'white';
  memoryUsed: number;
  totalMemory: number;
  totalPatients: number;
  scheduledPatients: number;
  totalCases: number;
  border:string;
  borderBottom:string;
  degree :string;
  experience :string;
  speciality :string;
  department :string;
  sex :string;
  dob:string;
  dobshow:string;
  eaHospId:string

}
